<template>
  <div>
    <v-btn
      v-if="actionType && activity.tasks[0].company_id"
      icon
      @click="$emit('remove', activity)"
    >
      <v-avatar size="25" :title="getCompanyName(activity.tasks[0].company_id)">
        <img :src="getCompanyImage(activity.tasks[0].company_id)" />
        <v-icon class="trash" size="20">delete</v-icon>
      </v-avatar>
    </v-btn>
    <v-btn
      class="button-hover"
      icon
      v-if="!actionType && activity && activity.company"
      @click="$emit('remove', activity, company)"
    >
      <v-avatar size="25" :title="company.name">
        <img :src="company.image" />
        <v-icon size="20">delete</v-icon>
      </v-avatar>
    </v-btn>
  </div>
</template>

<script>
import { activitiesTasksDataMixin } from "../../../../../mixins/field/activitiesTasksDataMixin";
export default {
  name: "AssignementRemoveButton",

  mixins: [activitiesTasksDataMixin],

  props: {
    /**
     * receives if actionType is view or edit
     */
    actionType: {
      type: String
    },
    /**
     * activity with assigned company
     */
    activity: {
      type: Object
    },
    /**
     * company assigned to activity
     */
    company: {
      type: Object
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/_Molecules/AssignmentRemoveButton.vue